import * as yup from "yup";

export const notificationSchema = yup.object().shape({
  header: yup.string().required("Title is required"),
  body: yup.string().required("Description is required"),
  notification_type: yup
    .string()
    .oneOf(
      ["OTHER", "MESSAGE", "BROADCAST"],
      "Please select a notification type"
    )
    .required("Notification type is required"),
  user_id: yup
    .array()
    .of(yup.string())
    .when("notification_type", (notificationType, schema) => {
      if (notificationType === "MESSAGE") {
        return schema.min(1, "At least one user must be selected for MESSAGE type").required();
      }
      return schema.notRequired();
    }),
});
